import React, { useEffect } from "react";
import { useState, useRef } from "react";

const VariantMeta = ({
  variation,
  index,
  variantDataHandler,
  variantData,
  inputRef,
}) => {
  const variantTitle = variation[`variation${index + 1}`];


  // const inputRef = useRef([]);
  // const focusInput = (index) => {
  // 	// Access the input element using the ref and focus it
  // 	if (inputRef.current[index] && inputRef.current[index].current) {
  // 		inputRef.current[index].current.focus();
  // 	}
  // 	const inputField = document.querySelector(`#varient-price-${index}`); // Replace with your input field's ID or another selector
  // 	if (inputField) {
  // 	  inputField.focus();
  // 	}
  //   };

  // console.log(variantData,variation ,"gtgftfrrere variantData",inputRef);

  // const currentVariantData = variantData[index];
  // console.log(currentVariantData ,'ttttttttt')

  const { price, qty, sku, discountPrice } = variantData[index] ?? {};

  return (
    <tr>
      <td className="color-size-small">{variantTitle}</td>
      <td>
        <div className="table-input">
          <input
            type="number"
            name="price"
            onChange={(e) => {
              variantDataHandler(e, index);
            }}
            value={price}
          />
        </div>
      </td>
      <td>
        <div className="table-input">
          <input
            type="text"
            name="discountPrice"
            onChange={(e) => variantDataHandler(e, index)}
            value={discountPrice}
            // id={`varient-discount-price-${index}`}
          />
        </div>
      </td>
      <td>
        <div className="table-input">
          <input
            type="text"
            name="qty"
            onChange={(e) => variantDataHandler(e, index)}
            value={qty}
            // id={`varient-qty-${index}`}
          />
        </div>
      </td>
      <td>
        <div className="table-input">
          <input
            type="text"
            name="sku"
            onChange={(e) => variantDataHandler(e, index)}
            value={sku}
            // id={`varient-sku-${index}`}
          />
        </div>
      </td>
    </tr>
  );
};

export default VariantMeta;
